import React from "react";
import {
  Container,
  Card,
  CardContent,
  Typography,
  Divider,
  List,
  ListItem,
  ListItemText,
  makeStyles,
} from "@material-ui/core";

const useStyles = makeStyles((theme) => ({
  root: {
    marginTop: theme.spacing(4),
    marginBottom: theme.spacing(4),
    background: 'linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%)',
    minHeight: '100vh',
    padding: theme.spacing(2),
  },
  card: {
    padding: theme.spacing(3),
    borderRadius: 20,
    boxShadow: "0 8px 32px rgba(0,0,0,0.1)",
    background: 'rgba(255, 255, 255, 0.95)',
    backdropFilter: 'blur(10px)',
  },
  heading: {
    fontWeight: 700,
    marginBottom: theme.spacing(2),
    background: 'linear-gradient(135deg, #667eea 0%, #764ba2 100%)',
    WebkitBackgroundClip: 'text',
    WebkitTextFillColor: 'transparent',
    textAlign: 'center',
  },
  sectionTitle: {
    fontWeight: 600,
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(1),
    color: '#667eea',
    borderLeft: '4px solid #667eea',
    paddingLeft: theme.spacing(2),
  },
  divider: {
    margin: theme.spacing(3, 0),
    background: 'linear-gradient(90deg, #667eea 0%, #764ba2 100%)',
    height: '2px',
  },
  listItem: {
    paddingLeft: 0,
    marginBottom: theme.spacing(1),
  },
  listItemText: {
    '& .MuiListItemText-primary': {
      fontSize: '1rem',
      lineHeight: 1.6,
    },
  },
}));

const RefundPolicy = () => {
  const classes = useStyles();

  return (
    <Container maxWidth="md" className={classes.root}>
      <Card className={classes.card}>
        <CardContent>
          <Typography variant="h4" className={classes.heading}>
            Refund & Cancellation Policy
          </Typography>
          {/* <Typography variant="body2" color="textSecondary" gutterBottom>
            Last Updated: 2nd Oct 2025
          </Typography> */}
          <Divider className={classes.divider} />

          <Typography variant="h6" className={classes.sectionTitle}>
            Ticket Purchases are Final
          </Typography>
          <Typography variant="body1">
            All confirmed ticket sales are non-refundable unless the event is
            cancelled or rescheduled.
          </Typography>

          <Typography variant="h6" className={classes.sectionTitle}>
            Event Cancellation or Rescheduling
          </Typography>
          <Typography variant="body1">
            If the organizer cancels or reschedules the event, customers will be
            notified, and refunds or ticket transfers will be processed as per
            organizer’s policy.
          </Typography>

          <Typography variant="h6" className={classes.sectionTitle}>
            No-Show / Customer Cancellations
          </Typography>
          <Typography variant="body1">
            No refunds will be issued for customer-initiated cancellations or
            no-shows.
          </Typography>

          <Typography variant="h6" className={classes.sectionTitle}>
            Refund Process
          </Typography>
          <List>
            <ListItem className={classes.listItem}>
              <ListItemText className={classes.listItemText} primary="Eligible refunds will be credited back to the original payment method within 7–14 working days." />
            </ListItem>
          </List>

          <Typography variant="h6" className={classes.sectionTitle}>
            Queries
          </Typography>
          <Typography variant="body1">
            For refund-related queries, contact us at: <b>amar@srshta.com</b>
          </Typography>
        </CardContent>
      </Card>
    </Container>
  );
};

export default RefundPolicy;
